import { debounce } from '@studiometa/js-toolkit/utils';

// Avoids repeated endpoint calls in case of multiple `input` events
const getResultDebounce = debounce((commit, state) => {
  const params = new URLSearchParams(state.formValues);
  const location = `${state.endpoints.results}?${params}`;

  fetch(location).then((response) => {
    response.json().then((data) => commit('SET_RESULTS', data));
  });

  return false;
}, 100);

export default {
  /**
   * Get geoJSON from the api
   * @description Get the geoJSON from the API, containning all the POI's data
   * @param {object} store
   * @param {Function} store.commit
   * @param {object} store.state
   */
  getGeojson({ commit, state }) {
    const location = state.endpoints.geojson;
    fetch(location).then((response) => {
      response.json().then((data) => commit('SET_GEOJSON', data));
    });
  },

  /**
   * Get Main filter from the api
   * @description Get the Main Filters in JSON format
   * @param {object} store
   * @param {Function} store.commit
   * @param {object} store.state
   */
  getMainFilters({ commit, state }) {
    const location = state.endpoints.mainFilters;

    fetch(location).then((response) => {
      response.json().then((data) => commit('SET_MAIN_FILTERS', data));
    });
  },

  /**
   * Get Secondary filter from the api
   * @description Get the Secondary Filters in JSON format
   * @param {object} store
   * @param {Function} store.commit
   * @param {object} store.state
   */
  getSecondaryFilters({ commit, state }) {
    const location = state.endpoints.secondaryFilters;

    fetch(location).then((response) => {
      response.json().then((data) => commit('SET_SECONDARY_FILTERS', data));
    });
  },

  /**
   * Get results
   * @description Get results from the API, the response return an Array of ID's
   * @param {object} store
   * @param {Function} store.commit
   * @param {object} store.state
   * @returns {boolean} false
   */
  getResults({ commit, state }) {
    return getResultDebounce(commit, state);
  },

  /**
   * setFormValues
   * @description Set the form values into the store
   * @param {object} store
   * @param {Function} store.commit mutation
   * @param {object} values
   * @param {string} values.name
   * @param {string} values.value
   */
  setFormValues({ commit }, { name, value }) {
    commit('SET_FORM_VALUES', { name, value });
  },

  /**
   * resetFormValues
   * @description Commit a full reset of the form values
   * @param {Function} commit mutation
   */
  resetFormValues({ commit }) {
    commit('RESET_FORM_VALUES');
  },
};
